import {
  AGE_END,
  AGE_START,
  BASE,
  BRANDS,
  FILTERS,
  PROFILE_GROUP,
  GROUPED_BY,
  MARKETS,
  MODE,
  PERIOD,
  PERIOD_END_DATE,
  PERIOD_START_DATE,
  PERIOD_TYPE,
  POST_END_DATE,
  POST_PERIOD_TYPE,
  POST_START_DATE,
  PROFILE_RESPONSE,
  QUESTION_OPTIONS,
  SECONDARY_BRANDS,
  SEGMENTS,
  STAT_TEST,
  VISUALIZATION_TYPE,
  TRENDS_METRIC,
  RESPONSE,
  VIEW_ID,
  SCORE_TYPE,
  PROFILE_METRIC
} from "./constantsThrougoutProject";

export const QO = "qo";
export const QR = "qr";
export const QU = "qu";

const ALL_URL_KEYS = [
  MARKETS,
  BRANDS,
  FILTERS,
  SEGMENTS,
  STAT_TEST,
  BASE,
  MODE,
  PERIOD_TYPE,
  PERIOD_START_DATE,
  PERIOD_END_DATE,
  POST_PERIOD_TYPE,
  POST_START_DATE,
  POST_END_DATE,
  PERIOD,
  VISUALIZATION_TYPE,
  AGE_START,
  AGE_END,
  GROUPED_BY,
  QUESTION_OPTIONS,
  SECONDARY_BRANDS,
  PROFILE_GROUP,
  PROFILE_METRIC,
  PROFILE_RESPONSE,
  TRENDS_METRIC,
  RESPONSE,
  VIEW_ID,
  SCORE_TYPE
];

export { ALL_URL_KEYS };
